<template>
  <n-config-provider :theme-overrides="themeOverrides" :locale="bxLocal" :dateLocale="dateLocal">
    <n-message-provider>
      <n-dialog-provider>
        <router-view v-slot="{ Component, route }" v-if="isMiniProgramRoute">
          <keep-alive>
            <component :is="Component" :key="route.fullPath" v-if="route.meta.isKeepAlive" v-show="!initializing" />
          </keep-alive>
          <component :is="Component" :key="route.fullPath" v-if="!route.meta.isKeepAlive" v-show="!initializing" />
        </router-view>
        <router-view v-else v-show="!initializing" />
      </n-dialog-provider>
    </n-message-provider>
    <div v-if="initializing" style="width: 100vw; height: 100vh; background: #fff; top: 0; left: 0; display: flex; align-items: center; justify-content: center">
      <n-spin size="large" />
    </div>
  </n-config-provider>
</template>

<script lang="ts" setup>
import { computed, ref, onMounted, onUnmounted } from "vue"
import { zhCN, dateZhCN, GlobalThemeOverrides } from "naive-ui"
import { useMainStore } from "@/store/main"
import { useEnvStore } from "@/store/EnvStore"
import { useOrderNotificationStore } from "@/store/OrderNotificationStore"
import { useRoute, useRouter } from "vue-router"

const mainStore = useMainStore()
const envStore = useEnvStore()
const orderNotificationStore = useOrderNotificationStore()
const router = useRouter()
const route = useRoute()

// 判断是否为小程序路由
const isMiniProgramRoute = computed(() => {
  return route.path.startsWith("/mp/")
})

const initializing = computed(() => mainStore.initializing)

const themeOverrides: GlobalThemeOverrides = {
  common: {
    primaryColor: "#48b02c",
    primaryColorHover: "#398c23",
    primaryColorPressed: "#398c23",
    primaryColorSuppl: "#398c23",
    borderColor: "#b4b4c0",
  },
  Layout: {
    headerColor: "#398c23",
  },
}

const bxLocal = ref(zhCN)
const dateLocal = ref(dateZhCN)

const setMobile = () => {
  envStore.setMobile(document.documentElement.clientWidth <= 768)
  envStore.setSize(document.documentElement.clientWidth, document.documentElement.clientHeight)
}

setMobile()
window.onresize = () => {
  setMobile()
}
envStore.setUerAgent(navigator.userAgent)

onMounted(() => {
  orderNotificationStore.initializeAll()
})

onUnmounted(() => {
  orderNotificationStore.cleanupAll()
})
</script>
